module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-org"
  }, [_c('div', {
    staticClass: "step-box"
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.active,
      "center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "确认申报信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "同意备案申明"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "上传备案文件"
    }
  })], 1), _vm._v(" "), (_vm.state == 1) ? _c('Otherdetail', {
    ref: "saveInfo"
  }) : _vm._e(), _vm._v(" "), (_vm.state == 2) ? _c('comfirmFile', {
    attrs: {
      "state": !_vm.isfalse,
      "message": _vm.paren
    },
    on: {
      "change": _vm.change
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('govUpload', {
    ref: "configUpdate",
    attrs: {
      "num": _vm.num,
      "fileLists": _vm.fileLists,
      "subjectId": _vm.subjectId,
      "planType": 'sudden'
    },
    on: {
      "change": _vm.changeIDName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 4) ? _c('GovFillInfo', {
    ref: "configGov",
    on: {
      "change": _vm.changeData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "org-control"
  }, [_c('el-button', {
    on: {
      "click": _vm.returnbank
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.state == 1) ? _c('el-button', {
    on: {
      "click": _vm.editApply
    }
  }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isfalse
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.sub_update))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认提交?",
      "visible": _vm.dialogclose,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogclose = $event
      }
    }
  }, [_c('p', {
    staticClass: "p-color1"
  }, [_vm._v("提交后信息无法修改,确认提交?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogclose = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认",
      "visible": _vm.dialogdelect,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogdelect = $event
      }
    }
  }, [_c('p', {
    staticClass: "p-color1"
  }, [_vm._v("返回后将放弃当前未保存的数据，确认返回？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogdelect = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delect
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "备案信息确认",
      "visible": _vm.dialogAuditSelect,
      "close-on-press-escape": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAuditSelect = $event
      }
    }
  }, [_c('div', {
    staticClass: "mg-bt10"
  }, [_vm._v(_vm._s(_vm.formatAuditRegion(_vm.auditRegions)))]), _vm._v(" "), _c('div', {
    staticClass: "mg-bt30"
  }, [_vm._v(_vm._s(_vm.dealOrg))]), _vm._v(" "), _c('p', [_vm._v("*说明：如即将提交的机构信息有误，请点击编辑按钮修改所属区划")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogAuditSelect = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.editApply
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.select_audit
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2e8ac48","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/burst/burstOtherStep.vue
// module id = 1281
// module chunks = 2